module.exports = __webpack_public_path__ + "static/media/cdb26.4b78cf5d.png";